import { DOCUMENT } from '@angular/common';
import { Directive, LOCALE_ID, inject } from '@angular/core';

import { getDirection } from './language-utils';

@Directive({
  selector: '[etnLanguage]',
  standalone: false,
})
export class LanguageDirective {
  public language = inject(LOCALE_ID);

  public constructor() {
    const document = inject<Document>(DOCUMENT);
    const language = this.language;

    document.dir = getDirection(language);
    document.documentElement.lang = language;
  }
}
